// extracted by mini-css-extract-plugin
export default {"settings":"RangeSettings_settings__WvBX4","column":"RangeSettings_column__531Zj","error":"RangeSettings_error__WbvJj","button":"RangeSettings_button__etvcQ"};